import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { StorageRoutingModule } from './storage-routing.module';
import { StorageComponent } from './storage.component';
import { StorageFormComponent } from './storage-form/storage-form.component';
import { StorageInputComponent } from './storage-input/storage-input.component';
import { MyCustomMaterialModule } from 'san-common';


@NgModule({
  imports: [
    CommonModule,
    MyCustomMaterialModule,
    StorageRoutingModule,

  ],
  declarations: [StorageComponent, StorageFormComponent,StorageInputComponent],
  exports: [StorageComponent, StorageFormComponent,StorageInputComponent]
})
export class StorageModule { }
